import { createLocalVue, shallowMount } from '@vue/test-utils';
import Vuex from 'vuex';

/**** TEST MODULE ****/
import CartSubscribeAndSave from './CartSubscribeAndSave';

/**** MOUNTING OPTIONS ****/
function createWrapper() {
  const store = new Vuex.Store({
    modules: store_modules,
  });

  return shallowMount(CartSubscribeAndSave, {
    localVue,
    methods,
    mocks,
    provide,
    stubs,
    store,
  });
}

const localVue = createLocalVue();
localVue.use(Vuex);

const methods = {
  trackEvent: jest.fn(),
};
const mocks = {};
const provide = {};
const stubs = {};

const setEditItemsMock = jest.fn(() => true);

const store_modules = {
  cart: {
    namespaced: true,
    getters: {
      subscribableItems: jest.fn(() => new Set([1, 2, 3]))
    },
    mutations: {
      setEditAllItems: setEditItemsMock
    }
  },
  customer: {
    namespaced: true,
    getters: {
      hasMembershipPricing: jest.fn(() => false)
    }
  }
};

let wrapper;

/**** TESTS ****/
describe('SubscribeAndSave', function () {
  describe('does not display content if the user is receiving membershipPricing', function() {
    wrapper = createWrapper();
    expect(wrapper.contains('.cart-subscribe-and-save')).toBe(true);

    store_modules.customer.getters.hasMembershipPricing = jest.fn(()=>true);
    wrapper = createWrapper();
    expect(wrapper.contains('.cart-subscribe-and-save')).toBe(false);

    store_modules.customer.getters.hasMembershipPricing = jest.fn(()=>false);
  });

  describe('does not display content if the user has no cart items available for subscribing', function() {
    store_modules.cart.getters.subscribableItems = jest.fn(()=>new Set());
    wrapper = createWrapper();
    expect(wrapper.contains('.cart-subscribe-and-save')).toBe(false);

    store_modules.cart.getters.subscribableItems = jest.fn(()=>new Set([1, 2, 3]));
  });

  test('expected function call when the subscribe button is clicked', function() {
    wrapper = createWrapper();

    const btn = wrapper.find('#cart-subscribe-and-save');
    btn.trigger('click');
    expect(setEditItemsMock.mock.calls.length).toBe(1);
  });
}); 